/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {ChangeEvent, FormEvent, PropsWithChildren, useEffect, useState} from 'react'
import {Button} from 'react-bootstrap'
import {Link, useNavigate} from 'react-router-dom'
import toast from 'react-hot-toast'
import axios from 'axios'
import {useAuth} from '../../auth'
import {
  GET_INVOICE_LIST_URL,
  IFilterInvoiceForm,
  IInvoiceList,
  IInvoiceListArray,
} from '../core/_model'
import {KTIcon} from '../../../../_metronic/helpers'
import {Params} from '../../Schedules/core/_model'
import {ListViewProvider} from '../../../utils/contextProvider/ListViewProvider'
import {BASE_URL} from '../../config'
import invoiceListColumn from './invoiceListColumn'
import usePaginationCounts from '../../../utils/hooks/usePaginationCounts'
import {useQuery} from 'react-query'
import {handleAxiosError, searchItems} from '../../../utils/helperFunction/_helper'
import TableContentHeader, {
  perPageItemsOptions,
} from '../../../utils/components/table-content/TableContentHeader'
import TableContent from '../../../utils/components/table-content/TableContent'
import TablePagination from '../../../utils/components/table-content/TablePagination'
import SelectEntriesOptions from '../../../utils/components/table-content/SelectEntriesOptions'
import FilterInvoice from './FilterInvoice'
import {Helmet} from 'react-helmet-async'
import InputSearchBox from '../../../utils/components/form/InputSearchBox'

const RechargeFrom = () => {
  const {currentUser} = useAuth()
  const navigate = useNavigate()
  const {
    pagination: {page, size, totalElement},
    handlePageChange,
    handlePagePerItem,
    updatePagination,
  } = usePaginationCounts(1, 10)

  const [invoiceList, setInvoiceList] = useState<IInvoiceListArray>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [filterValues, setFilterValues] = useState<Partial<IFilterInvoiceForm>>({
    userId: null,
    sdate: '',
    edate: '',
  })

  const {isLoading, data, error} = useQuery({
    queryKey: ['invoiceList', {page, size}, filterValues],
    queryFn: async () => {
      // toast.loading('Processing..')
      const params: Record<string, any> = {page, size}

      if (filterValues.userId) params.userId = filterValues.userId
      if (filterValues.sdate) params.sdate = filterValues.sdate
      if (filterValues.edate) params.edate = filterValues.edate

      const response = await axios.get(`${BASE_URL}/api/protect/getAllInvoices`, {params})
      const data = await response.data

      return {
        list: data.data,
        pagination: data.pagenationResponse,
      }
    },
    onSuccess: () => {
      toast.dismiss()
      toast.success('Invoice list retrieved')
    },
    onError: (error) => {
      toast.dismiss()
      const message = handleAxiosError(error)
      toast.error(message)
    },
  })

  const onCreateInvoice = () => {
    navigate('/billing/invoice/create')
  }

  const onFilter = (sendvalues: Partial<IFilterInvoiceForm>) => {
    console.log(sendvalues)
    toast.loading('Processing..')
    setInvoiceList([])
    setFilterValues(sendvalues)
  }

  useEffect(() => {
    if (data) {
      console.log(data)
      const keys: (keyof IInvoiceList)[] = ['invoice_no', 'type']
      const filtered = searchItems(data.list, searchTerm, keys)
      console.log(filtered)
      setInvoiceList(filtered || [])
      updatePagination(data.pagination)
    }
  }, [data, searchTerm])

  return (
    <ListViewProvider isLoading={isLoading} data={invoiceList}>
      <Helmet>
        <title>Invoice List</title>
      </Helmet>
      <div className='d-flex justify-content-between align-items-center mb-3 gap-4 flex-wrap'>
        <InputSearchBox
          placeholder='Search'
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        <div className='d-flex gap-2'>
          <FilterInvoice onFilter={onFilter} handlePagePerItem={handlePagePerItem} size={size} />

          {currentUser?.user_profile !== 3 && (
            <div>
              <button type='button' className='btn btn-primary' onClick={onCreateInvoice}>
                <KTIcon iconName='plus' className='fs-2' />
                Create Invoice
              </button>
            </div>
          )}
        </div>
      </div>

      {/* <div className='d-flex align-items-center justify-content-between'>
        <SelectEntriesOptions
          options={perPageItemsOptions}
          handleSelect={handlePagePerItem}
          value={size.toString()}
        />

        <FilterInvoice />
      </div> */}

      {/* <TableContentHeader size={size} handlePagePerItem={handlePagePerItem} /> */}
      <>
        <TableContent
          isLoading={isLoading}
          tableData={invoiceList}
          tableColumn={invoiceListColumn}
          error={error as Error}
        >
          {isLoading && !data ? (
            <div className='d-flex justify-content-center'>
              <div className='spinner-border' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : (
            <TablePagination
              totalElement={totalElement}
              isLoading={isLoading}
              itemsPerPage={size}
              currentPage={page}
              handlePageChange={handlePageChange}
            />
          )}
        </TableContent>
      </>
    </ListViewProvider>
  )
}

export default RechargeFrom
